// @ts-nocheck
import { Action, getModule, Module, MutationAction, VuexModule } from 'vuex-module-decorators';
import store from '@/store';
import { ISources, ISourcesCreate } from '@/entity/sources/sources.types';
import { ResponseDataType } from '@/form/form.types';

@Module({
    namespaced: true,
    name: 'sources',
    store,
    dynamic: true
})
class SourcesModule extends VuexModule {
    sources: ISources[] = [];
    sourcesLoaded = false;

    @MutationAction
    async fetchAll(salonId?: number): Promise<{ sources: ISources[]; sourcesLoaded: boolean }> {
        const sources = await store.$repository.sources.fetchAll(salonId);
        let sourcesLoaded = false;
        if (sources.length > 0) {
            sourcesLoaded = true;
        }
        return { sources, sourcesLoaded };
    }
    @Action({rawError: true})
    async create(data: ISourcesCreate): Promise<ResponseDataType> {
        return await store.$repository.sources.create(data)
    }
    @Action({ rawError: true })
    async update(data: any) {
        return  await store.$repository.sources.update(data);
    }
    
    @Action({ rawError: true })
    async delete(id: any) {
        return await store.$repository.sources.delete(id);
    }

}

export const SourcesStore = getModule(SourcesModule);
